export default {
  name: 'Checkbox',
  props: {
    label: {
      type: String,
      default: '',
    },
    leftLabel: Boolean,
    disable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
    },
  },
  computed: {
    classes() {
      return {
        disabled: this.disable,
        checked: this.value === true,
      };
    },
    dynamicTabIndex() {
      return this.$props.disable ? '-1' : '0';
    },
  },
  methods: {
    toggle(e) {
      if (this.disable) return;
      if (['a', 'input'].includes(e.target.nodeName.toLowerCase())) return;
      this.$emit('input', !this.value);
      this.$emit('toggle', !this.value);
    },
  },
};
